export type SeriesPagesGateState = 'allowed' | 'blocked' | 'pending'

type SeriesPagesGateInput = {
  hasProfile: boolean
  hasEmrEnabled: boolean
  showSeries: boolean
}

// hasEmrEnabled is false until the profile answers, so wait for it before blocking.
export const seriesPagesGate = ({
  hasProfile,
  hasEmrEnabled,
  showSeries,
}: SeriesPagesGateInput): SeriesPagesGateState => {
  if (!showSeries) return 'blocked'
  if (!hasProfile) return 'pending'
  return hasEmrEnabled ? 'allowed' : 'blocked'
}
